import { render, staticRenderFns } from "./layoutFooterTwo.vue?vue&type=template&id=7594ec79&scoped=true"
import script from "./layoutFooterTwo.vue?vue&type=script&lang=js"
export * from "./layoutFooterTwo.vue?vue&type=script&lang=js"
import style0 from "./layoutFooterTwo.vue?vue&type=style&index=0&id=7594ec79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7594ec79",
  null
  
)

export default component.exports